<template>
	<div class="">
		<div class="row justify-content-between pl-2 pr-4">
			<h6 class="font-weight-bold">LIST OF SUB MENUS</h6>
			<button v-if="menuId && hasSubMenu == 1" @click="createSubMenu()" class="btn btn-primary btn-sm">Create Sub-menu</button>
		</div>

		<vue-bootstrap4-table 
			:rows="rows"
			:columns="columns"
			:config="config">

			<template slot="id" slot-scope="props">
				<span>
					{{props.row.vbt_id}}
				</span>
			</template>

			<template slot="action" slot-scope="props">
				<div class="btn-group" role="group" aria-label="Sub-Menu Actions">
					<button type="button" @click="editMenu(props.cell_value)" class="btn btn-primary btn-sm mr-1">
						Edit
					</button>
					<button type="button" @click="deleteMenu(props.cell_value)" class="btn btn-danger btn-sm">
						Delete
					</button>
				</div>     
			</template>

			<template slot="sort-asc-icon">
				<i class="fas fa-sort-up"></i>
			</template>
			<template slot="sort-desc-icon">
				<i class="fas fa-sort-down"></i>
			</template>
			<template slot="no-sort-icon">
				<i class="fas fa-sort"></i>
			</template>
		</vue-bootstrap4-table>
	</div>
</template>

<script>
import VueBootstrap4Table from 'vue-bootstrap4-table';
import { mapState } from 'vuex';
export default {
	name: "ListSubMenu",

	props: [
		'menuId',
		'hasSubMenu',
		'rows',
	],

	components: {
        VueBootstrap4Table,
	},

	computed: {
        ...mapState(['token']),
	},
	
	data() {
		return {
            columns: [
                {
                    label: "S/N",
                    name: "id",
                    slot_name: "id"
                },
                {
                    label: "Sub-Menu Name",
                    name: "subMenuName",
                    sort: true,
                },
                {
                    label: "Sub-Menu URL",
                    name: "subMenuUrl",
                    sort: true,
                },
                {
                    label: "Action",
                    name: "id",
                    slot_name: "action"
                },
            ],
            config: {
                card_mode: false,
                checkbox_rows: false,
                rows_selectable: false,
                show_refresh_button: false,
                show_reset_button: false,
                global_search: {
                    placeholder: "Search",
                    visibility: true,
                    case_sensitive: false,
                },
			},
		}
	},

	methods: {
		createSubMenu(){
			this.$emit('createsubmenu');
		},

		editMenu(menuId){
			const subMenu = this.rows.find(row => row.id == menuId);
			this.$emit('editsubmenu', subMenu);
		},

		deleteMenu(menuId){
			this.$emit('deletesubmenu', menuId);
		},
	}
}
</script>